import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { grey } from "@mui/material/colors";
import "react-circular-progressbar/dist/styles.css";
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';

const CircularProgressComponent = ({
  label,
  labelValue,
  value,
  colorTo,
}) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        maxWidth: 70,
        maxHeight: 70,
        width: "100%",
        height: "100%",
      }}
    >
      <CircularProgressbarWithChildren
        value={value}
        minValue={0}
        maxValue={100}
        styles={buildStyles({
          pathColor: colorTo,
          trailColor: theme.palette.mode === 'dark' ? grey[900] : grey[200]
        })}
      >
        <Typography sx={{ color: colorTo ? colorTo : grey[700] }} fontWeight={'bold'} fontSize={12}>
          {labelValue}
        </Typography>

        <Typography sx={{ color: colorTo ? colorTo : grey[700] }} fontSize={11}>{label}</Typography>

      </CircularProgressbarWithChildren>
    </Box>
  );
};

export default CircularProgressComponent;
